import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[var(--charcoal)] text-white py-16">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Institut Info */}
          <div>
            <h3 className="font-['Cormorant_Garamond'] text-2xl mb-4 text-[var(--gold)]">
              Institut Madame DSRS
            </h3>
            <p className="text-sm text-white/70 mb-4 leading-relaxed">
              Votre institut de beauté premium dédié à l'onglerie, la pédicure et le bien-être.
              Une expérience unique dans un cadre confidentiel et élégant.
            </p>
            <div className="flex flex-col gap-2 text-sm text-white/70">
              <a href="mailto:contact@madamedsrs.fr" className="flex items-center gap-2 hover:text-[var(--gold)] transition-colors">
                <Mail size={16} />
                contact@madamedsrs.fr
              </a>
              <a href="tel:+33100000000" className="flex items-center gap-2 hover:text-[var(--gold)] transition-colors">
                <Phone size={16} />
                07.61.33.37.72
              </a>
              <span className="flex items-center gap-2">
                <MapPin size={16} />
                Val d'Oise, Attainville (Adresse privée)
              </span>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="uppercase tracking-[0.2em] text-xs font-medium mb-4 text-[var(--rose-gold)]">
              Navigation
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-home">
                Accueil
              </Link>
              <Link to="/onglerie-pedicure" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-onglerie">
                Onglerie & Pédicure
              </Link>
              <Link to="/bien-etre" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-bienetre">
                Bien-être
              </Link>
              <Link to="/press-on-nails" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-pressonnails">
                Press On Nails
              </Link>
              <Link to="/atelier-evenementiel" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-atelier">
                Atelier Événementiel
              </Link>
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h4 className="uppercase tracking-[0.2em] text-xs font-medium mb-4 text-[var(--rose-gold)]">
              Informations légales
            </h4>
            <nav className="flex flex-col gap-3">
              <Link to="/mentions-legales" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-mentions">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-confidentialite">
                Politique de confidentialité
              </Link>
              <Link to="/cgv" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-cgv">
                Conditions générales de vente
              </Link>
              <Link to="/mon-compte" className="text-sm text-white/70 hover:text-[var(--gold)] transition-colors" data-testid="footer-link-compte">
                Mon Compte
              </Link>
            </nav>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-white/10 pt-8 text-center">
          <p className="text-xs text-white/50 tracking-wider">
            © {new Date().getFullYear()} Institut Madame DSRS. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};
